// src/components/LogoutButton.jsx
import { useAuth } from '../providers/AuthProvider'

export default function LogoutButton() {
  const { signOut } = useAuth()

  // signOut function in AuthProvider already handles aggressive cleanup and location.replace
  const handleSignOut = async (e) => {
    e?.stopPropagation()
    e?.preventDefault()
    await signOut()
  }

  return (
    <button
      onClick={handleSignOut}
      // z-50 relative 추가로 클릭 씹힘 방지
      className="relative z-50 px-3 py-1.5 rounded-md border hover:bg-gray-50 text-sm cursor-pointer"
      title="로그아웃"
    >
      로그아웃
    </button>
  )
}
